import {observable, action, runInAction, computed} from 'mobx'
import {get, json} from '../../../../utils/ajax'
import {handleSeerchAndPage, objToForm, ValueObjToObj, setStore, downLoad} from "../../../../utils/Utils";
import {message} from 'antd'
import moment from 'moment'
import scrollIntoView from 'scroll-into-view';

class epcSparepartCatalogAttributeStore {
    @observable list
    @observable pagination
    @observable carseries
    @observable loading
    @observable searchFields
    @observable updateModal  //modal
    @observable carseriesList//接收查出的车系列表
    @observable tree //左侧目录树
    @observable createCatalogSparePart
    @observable createData
    @observable updateData
    @observable catalogList
    @observable UploadModal
    @observable queryFileds
    @observable Flag
    @observable carseriesList1
    @observable epcSparepartsId //备件id
    @observable catalogId //目录id
    @observable CatalogSpaarParePartId //中间表id
    @observable fileList
    @observable downloadLoading//导出loading状态
    @observable carId//回显添加弹出层的车系
    @observable group//存放组号
    @observable createBtnIsShow//新增按钮是否显示
    @observable formField//打印修改说明模态框选择的值
    @observable exportPdfModalValue//打印pdf模态框下拉框的值
    @observable ModificationNotes//修改说明模态框是否显示
    @observable pdfBtnIsShow//pdf打印按钮
    @observable excelModalIsShow//导出excel模态框
    @observable excelDownloadLoading//导出excel按钮
    @observable carCode//保存页面车系下拉时选中数据的code
    @observable carName//保存页面车系下拉时选中数据的name
    @observable editCatalogSparePart
    @observable createDataCode
    @observable linkage
    @observable carEdition//车系版本号
    @observable technologyModal//技术属性模态框
    @observable editTechnologyData//技术属性模态框
    @observable editQueryAllDataModal//查询所有数据模态框
    @observable queryData
    @observable selectedRowKeys//选中行
    @observable technologyLoading
    @observable initSelectData//查询所有数据模态框页面初始下拉框值
    @observable technologyRow
    @observable editCarseriesCode
    @observable editCatalogId
    @observable selectLeftRowId
    @observable selectLeftRowData
    @observable expandedLeftRowKeys
    @observable queryAllDataLoading
    @observable initExportSelectData
    @observable selectedRowKeysId//选中行的id
    @observable selectLeftRowMaterialNo//选中行的物料号
    @observable gradeVal//标号改变时的值
    @observable gradeValIndex
    @observable vinExportVisible //vin导出框
    @observable vinValue //vin导出值
    @observable showReplaceModal //备件变更查看框
    @observable replaceDetail //备件变更查看框
    @observable isPmm //判断该车型是否来自PMM
    @observable getSelectKey //获取备件导出年款
    @observable powerSet
    @observable allocationSet
    @observable transTypeSet
    @observable driveTypeSet
    @observable emissionNormalSet
    @observable modelStatus
    @observable showDrawer
    @observable importReturnData
    @observable epcCountVal//数量改变时的值
    @observable epcCountValIndex
    @observable createEditTitle  //模态框名
    @observable queryAllDataModal  //数据模态框
    @observable createEditModal   //修改备件模态框
    @observable editInfoModal   //修改说明模态框
    @observable exportExcelModal   //备件导出模态框
    @observable technicalSettingModal  //技术属性模态框
    @observable vinExportModal  //vin导出模态框
    @observable dragState //是否显示拖拽后保存按钮
    @observable epcSparepartsCatalogId//保存上传附件ID
    @observable catalogCode//保存点击3级目录code
    @observable vinExportSparePartsModal //vin导出
    @observable vin //vin

    constructor() {
        this.powerSet = [];
        this.allocationSet = []
        this.transTypeSet = []
        this.driveTypeSet = []
        this.emissionNormalSet = []
        this.list = []
        this.carseries = {}
        this.updateModal = false
        this.carseriesList = []
        this.carseriesList1 = []
        this.tree = []
        this.createCatalogSparePart = false
        this.UploadModal = false
        this.catalogList = []
        this.Flag = ''
        this.epcSparepartsId = ''
        this.catalogId = ''
        this.CatalogSpaarParePartId = ''
        this.fileList = []
        this.createData = {
            carseriesName: '',
            // carseriesId: '',
            code: '',
            spareNo: '',
            spareName: '',
            materialCode: '',
            grade: '',
            epcCount: '',
            groupDescription: '',
            developRemarks: '',
            salesRemarks: ''
        }
        this.updateData = {
            attachment: '',
            id: '',
            grade: '',
            epcCount: '',
            location: '',
            vinNo: '',
            engineCode: '',
            developRemarks: '',
            salesRemarks: ''
        }
        this.searchFields = {
            sparepNo: '',
            materialCode: '',
            carseriesId: ''
        }
        this.queryFileds = {
            catalogId: '',
            carseriesCode: '',
        }
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.downloadLoading = false
        this.carId = ""
        this.group = ""
        this.createBtnIsShow = false
        this.formField = {
            modelYearSet: [],
            powerSet: [],
            allocationSet: [],
            transTypeSet: [],
            driveTypeSet: [],
            emissionNormalSet: [],
        }
        this.exportPdfModalValue = {
            carYears: [],//年款
            displacements: [],//排量
            deploys: [], //配置
            transmissions: [], //变速器类型
            driveModels: [],  //驱动方式
            countryAreas: [], //国家及大区
            emissionNormal: []//排放标准
        }

        this.ModificationNotes = false
        this.pdfBtnIsShow = false
        this.excelModalIsShow = false
        this.excelDownloadLoading = false
        this.carCode = ''
        this.carName = ''
        this.editCatalogSparePart = {}
        this.createDataCode = ''
        this.linkage = ''
        this.carEdition = ''
        this.technologyModal = false
        this.editTechnologyData = {}
        this.editQueryAllDataModal = false
        this.queryData = []
        this.selectedRowKeys = []
        this.technologyLoading = false
        this.queryAllDataLoading = false
        this.technologyRow = {}
        this.initSelectData = {
            netWeightList: {},
            regulationsList: {},
            sparePartTypeList: {},
            sparePartSourceList: {},
            sparePartStatusIdentifierList: {},
            dataSourcesList: {},
            purchasingChannelList: {},
            IndustryTypeList: {},
            materialTypeList: {},
            basicUnitOfMeasureList: {},
            commodityInspectionMarkList: {},
            productGroupList: {},
            materialGroupList: {},
        }
        this.editCarseriesCode = ''
        this.editCatalogId = ''
        this.selectLeftRowId = ''
        this.selectLeftRowData = {}
        this.expandedLeftRowKeys = []
        this.initExportSelectData = {}
        this.selectedRowKeysId = []
        this.selectLeftRowMaterialNo = ''
        this.gradeVal = ''
        this.gradeValIndex = ''
        this.vinExportVisible = false
        this.vinValue = ''
        this.showReplaceModal = false
        this.replaceDetail = []
        this.isPmm = ''
        this.getSelectKey = []
        this.modelStatus = false
        this.showDrawer = false
        this.importReturnData = []
        this.epcCountVal = ''
        this.epcCountValIndex = ''
        this.queryAllDataModal = false
        this.createEditModal = false
        this.createEditTitle = ''
        this.editInfoModal = false
        this.exportExcelModal = false
        this.technicalSettingModal = false
        this.vinExportModal = false
        this.dragState = false
        this.epcSparepartsCatalogId = ''
        this.catalogCode = ''
        this.vinExportSparePartsModal = false
        this.vin = ''
    }

    tableHandleScroll = () => {
        setTimeout(function () {
            scrollIntoView(document.querySelector('.rowSelect'), {
                behavior: 'smooth', block: 'start',
                align: {
                    top: 0,
                },
            });
        }, 1000);
    }

    /**
     * 主页面搜索表单的值绑定
     * @param changedFields
     */
    @action
    searchSpareAndCatalogBonding(changedFields) {
        runInAction(() => {
            this.searchFields = {
                content: changedFields.content ? changedFields.content.value : this.searchFields.content
            }
        })
    }

    /**
     * 新增备件值绑定
     */
    @action
    searchSparePartBonding(changedFields) {
        this.createData = {...this.createData, ...changedFields}
    }

    /**
     * 修改值绑定
     */
    @action
    updateSparePartBonding(changedFields) {
        runInAction(() => {
            this.updateData = {
                attachment: changedFields.attachment ? changedFields.attachment.value : this.updateData.attachment,
                id: changedFields.id ? changedFields.id.value : this.updateData.id,
                grade: changedFields.grade ? changedFields.grade.value : this.updateData.grade,
                epcCount: changedFields.epcCount ? changedFields.epcCount.value : this.updateData.epcCount,
                location: changedFields.location ? changedFields.location.value : this.updateData.location,
                vinNo: changedFields.vinNo ? changedFields.vinNo.value : this.updateData.vinNo,
                engineCode: changedFields.engineCode ? changedFields.engineCode.value : this.updateData.engineCode,
                developRemarks: changedFields.developRemarks ? changedFields.developRemarks.value : this.updateData.developRemarks,
                materialCode: changedFields.materialCode ? changedFields.materialCode.value : this.updateData.materialCode,
            }
        })
    }

    /**
     * 清空
     */
    @action
    clearSearch = () => {
        this.loading = true;
        runInAction(() => {
            this.searchFields = {
                content: '',
            }
            this.loading = false;
        })
    }

    @action
    empetyTree = () => {
        runInAction(() => {
            //清空树
            this.tree = []
            //清空已选车系值
            this.searchFields = {
                content: '',
                materialCode: '',
                sparepNo: '',
                carseriesId: ''
            }
            //隐藏添加按钮
            this.createBtnIsShow = false
            //清空车系
            this.carId = ''
            this.list = []
        })
    }

    /**
     * 首页选择车系下拉框
     * @returns {Promise.<void>}
     */
    @action
    initCarseries = async () => {
        runInAction(() => {
            this.list = []  //第一次进入页面时清空之前搜索的值
            this.pagination = { //第一次进入页面清空分页
                current: 0,
                total: 1,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: 20,
                showTotal: () => {
                }
            }
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epcSparepart/queryCarList`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.carseriesList = res || []
            this.loading = false
        })
    }


    /**
     * 根据车系id查询目录树
     */
    @action
    initEditPageCarseries = async (carseriesName) => {
        if (!carseriesName) {
            this.tree = []
            this.list = []
            this.searchFields = {
                content: '',
            }
            this.carId = ''
            this.linkage = ''
            this.createBtnIsShow = false
            this.clearSearch()
        }
        if (carseriesName) {
            this.loading = true
            this.pagination.total = 0
            this.pagination.current = 0
            //查询左侧树
            let carCodeData = this.carseriesList.find(item => item.carseriesName === carseriesName)
            this.carCode = carCodeData.carSeriesCode;
            this.carName = carCodeData.carseriesName;
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/queryCatalogListByCarCode/carCode?carCode=${this.carCode}`);
            if (res && res.status === 0) {
                runInAction(() => {
                    this.loading = false
                })
                return
            }
            const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/edition/getEditionNoByCarseriesCode/carseriesCode?carseriesCode=${this.carCode}`);
            runInAction(() => {
                this.carEdition = res1
                this.carId = carCodeData.carseriesId
                this.createBtnIsShow = false
                this.group = ""
                this.searchFields = {
                    content: '',
                    materialCode: '',
                    sparepNo: '',
                    carseriesId: carCodeData.carseriesId
                }
                this.formField.carSeriesId = carCodeData.carseriesId
                this.list = []
                this.tree = this.findChildren(res)
                this.loading = false
            })
        }
    }

    //遍历数组，当children为空时删除，去除掉前台显示的展开图标
    @action
    findChildren = (arr) => {
        for (let i in arr) {
            if (!arr[i].children.length) {
                delete arr[i].children;
            } else {
                this.findChildren(arr[i].children)
            }
        }
        return arr
    }


    /**
     * 通过和车系code、三级目录id获得信息
     * @param record
     * @param page
     * @returns {Promise.<void>}
     */
    @action
    searchByPathAndcarseriesId = async (page, record) => {
        this.linkage = record.description
        this.selectLeftRowId = record.id
        this.selectLeftRowData = record
        this.catalogCode = record.code
        if (record.level !== 3) {
            return
        }
        runInAction(() => {
            this.loading = true
            this.queryFileds.carseriesCode = record.carseriesCode
            this.queryFileds.catalogId = record.id
        })
        this.createDataCode = record.code + record.name
        this.searchFields.carseriesCode = record.carseriesCode
        this.searchFields.catalogId = record.id
        let search = handleSeerchAndPage(page, this.pagination, this.searchFields)
        search.content = this.searchFields.content
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/getCatalogSpareparts:search`, search)
        runInAction(() => {
            this.loading = false
            this.group = record.path
            this.editCarseriesCode = this.carCode
            this.editCatalogId = record.id
            this.list = Array.isArray(res) ? res : []
            this.createBtnIsShow = true
            this.selectedRowKeysId = []
            this.gradeValIndex = ''
            this.epcCountValIndex = ''
        })
    }

    /**------------------------------------主页搜索-----------------------------------------------------------------*/
    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 根据表单的条件请求的数据
     * @param page
     * @returns {Promise.<void>}
     */
    @action
    searchCatalogSpartInfo = async (page) => {
        if (!this.carId) {
            message.warning("请先选择车系")
            return
        }
        this.queryAllDataLoading = true
        this.editQueryAllDataModal = true
        this.searchFields = {
            carseriesCode: this.carCode,
            content: this.searchFields.content,
        }
        let search = handleSeerchAndPage(page, this.pagination, this.searchFields)
        search.size = this.pagination.pageSize
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/getByCarseriesCodeAndContentForPage:search`, search)
        runInAction(() => {
            this.queryData = res && res.content
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.queryAllDataLoading = false
            this.queryAllDataModal = true
        })
    }

    /**--------------------------------------------新增备件-----------------------------------------------------*/
    /**
     * 通过备件编号查看该备件是否存在
     * @returns {Promise.<void>}
     */
    selectBySparepNo = async (spareNo) => {
        if (this.createData.spareNo.value) {
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/sparePart/getBySpareNo/spareNo/${spareNo}`)
            if (!res.spareName && !res.materialNo) {
                runInAction(() => {
                    this.createData.spareName = {value: ""}
                    this.createData.materialNo = {value: ""}
                    message.warning("请输入正确的备件编号")
                })
                return
            }
            runInAction(() => {
                this.epcSparepartsId = res;
                this.createData = {
                    ...this.createData,
                    spareName: {value: res.spareName},
                    materialNo: {value: res.materialNo},
                    spareNo: {value: spareNo},
                }
            })
        }
    }

    /**
     * 根据物料号查询备件名称
     * @param materialNo
     * @returns {Promise<void>}
     */
    @action
    selectByMaterialNo = async (materialNo) => {
        if (this.createData.materialNo.value) {
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/sparePart/getByMateralNo/materialNo/${materialNo}`);
            res.spareNo ? this.createData.spareNo = {value: res.spareNo} : this.createData.spareNo = {value: ''};
            if (!res.spareName) {
                runInAction(() => {
                    this.createData.spareName = {value: ''};
                    this.loading = false
                    message.warning("请输入正确的物料编号")
                })
                return
            }
            runInAction(() => {
                this.createData = {
                    ...this.createData,
                    spareName: {value: res.spareName}
                }
            })
        }
    }

    /**
     * 组号初始化
     * @param carId
     * @returns {Promise.<void>}
     */
    @action
    initcatalogs = async (carId) => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/catalogs/level3/carseriesId/${carId}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.catalogList = res
        })
    }

    /**
     * 新增备件并车系下拉框初始化
     * @returns {Promise.<void>}
     */
    @action
    addCatalogSparePart = async (record) => {
        this.createCatalogSparePart = true
        this.editCatalogSparePart = record
        if (record && record.id) {//修改
            this.loading = true
            this.createEditTitle = '修改备件'
            let id = record.id
            const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/getById/${id}`)
            runInAction(() => {
                this.loading = false
                this.createData = {
                    carseriesName: {value: this.carName},
                    carseriesId: {value: res.carseriesId},
                    code: {value: this.catalogCode},
                    spareNo: {value: res.spareNo},
                    spareName: {value: res.spareName},
                    materialNo: {value: res.materialNo},
                    grade: {value: res.grade},
                    epcCount: {value: res.epcCount},
                    groupDescription: {value: res.groupDescription},
                    vinNumber: {value: res.vinNumber},
                    engineNumber: {value: res.engineNumber},
                    color: {value: res.color},
                    location: {value: res.location},
                    specificationModel: {value: res.specificationModel},
                    developRemarks: {value: res.developRemarks},
                    salesRemarks: {value: res.salesRemarks},
                    enRemarks: {value: res.enRemarks},
                }
                this.createEditModal = true
            })
        } else {//新增
            this.createEditTitle = '新增备件'
            runInAction(() => {
                this.createData = {
                    carseriesName: {value: this.carName},
                    carseriesId: '',
                    code: {value: this.catalogCode},
                    spareNo: '',
                    spareName: '',
                    materialCode: '',
                    grade: '',
                    epcCount: '',
                    vinNumber: '',
                    engineNumber: '',
                    color: '',
                    location: '',
                    specificationModel: '',
                    groupDescription: ''
                }
                this.createEditModal = true
            })
        }
    }


    /**
     * 保存新增备件/修改备件信息
     * @returns {Promise.<void>}
     */
    @action
    saveCatalogSparePart = async () => {
        this.loading = true
        this.createData = {
            ...this.createData,
            catalogId: {value: this.queryFileds.catalogId},
            epcSparepartsId: {value: this.epcSparepartsId.id},
            carseriesCode: {value: this.carCode},
            path: {value: this.group}
        }
        if (this.editCatalogSparePart && this.editCatalogSparePart.id) {//修改
            this.createData.id = {value: this.editCatalogSparePart.id}
            let arr = this.list.find(item => item.id === this.editCatalogSparePart.id)
            this.createData.epcSparepartsId = {value: arr.epcSparepartsId}
            const res1 = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/updateCatalogSparePart`, ValueObjToObj(this.createData))
            if (res1.msg === "网络错误") {
                message.warning('该标号已存在，请采用不同备注才能新增!')
            }
            await this.queryAllConfigByCondition()
            let search = handleSeerchAndPage(this.pagination.current, this.pagination, this.searchFields)
            this.searchFields.carseriesCode = this.carCode
            this.searchFields.catalogId = this.editCatalogId
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/getCatalogSpareparts:search`, search)
            runInAction(() => {
                this.list = Array.isArray(res) ? res : []
            })
        } else {//新增
            const res1 = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/addCatalogSparePart`, ValueObjToObj(this.createData))
            if (res1.msg === "网络错误") {
                message.warning('该标号已存在，请采用不同备注才能新增!')
            }
            if (this.tree.length > 0) {
                await this.queryAllConfigByCondition()
                let search = handleSeerchAndPage(this.pagination.current, this.pagination, this.searchFields)
                this.searchFields.carseriesCode = this.carCode
                this.searchFields.catalogId = this.editCatalogId
                const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/getCatalogSpareparts:search`, search)
                runInAction(() => {
                    this.list = Array.isArray(res) ? res : []
                })
            }
            runInAction(() => {
                this.createData = {
                    carseriesName: this.createData.carseriesName.value,
                    carseriesId: '',
                    code: this.createData.code.value,
                    spareNo: '',
                    spareName: '',
                    materialCode: '',
                    grade: '',
                    epcCount: '',
                    groupDescription: ''
                }
            })
        }
        runInAction(() => {
            this.loading = false
            this.createCatalogSparePart = false
        })
    }

    /**
     * 关闭新增零件弹框
     */
    @action
    closeDataBox = () => {
        runInAction(() => {
            this.createData = {
                carseriesName: this.createData.carseriesName.value,
                carseriesId: '',
                code: this.createData.code.value,
                spareNo: '',
                spareName: '',
                materialCode: '',
                grade: '',
                epcCount: '',
                groupDescription: ''
            }
            this.createCatalogSparePart = false
            this.createEditModal = false
        })
    }

    /**
     * 清空新增表单
     */
    @action
    clearCreate = () => {
        runInAction(() => {
            this.loading = true;
            this.createData = {
                carseriesName: this.createData.carseriesName.value,
                carseriesId: '',
                code: this.createData.code.value,
                spareNo: '',
                spareName: '',
                materialCode: '',
                grade: '',
                epcCount: '',
                groupDescription: ''
            }
            this.loading = false;
        })
    }

    /**----------------------------------------------------------------- 修改备件 ----------------------------/
     /**
     * 修改需回显
     * @returns {Promise<void>}
     */
    @action
    selectById = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc_sparepart/get_by_id/${id}`)
        runInAction(() => {
            if (res.attachment === 'null' && res.attachment !== '') {
                this.fileList = [{
                    uid: -1,
                    name: '已上传的文档',
                    status: 'done',
                    url: res.attachment,
                }]
            }
            this.CatalogSpaarParePartId = id
            this.updateData = res
            this.loading = false
            this.updateModal = true
        })
    }

    /**
     * 保存修改信息
     */
    @action
    updateCatalogSparePart = async () => {
        runInAction(() => {
            this.loading = true
            this.updateData.id = this.CatalogSpaarParePartId
            this.updateData.epcCount = this.updateData.epcCount === undefined ? 0 : this.updateData.epcCount
        })
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc_sparepart/put_catalog_sparepart`, this.updateData)
        await this.searchByPathAndcarseriesId(this.pagination.current, this.list)
        runInAction(() => {
            this.updateData = {}
            this.loading = false
            this.updateModal = false
        })
    }

    /**-----------------------------删除-----------------*/
    /**
     * 删除弹框
     * @returns {Promise.<void>}
     */
    @action
    updateIsDelete = async (record) => {
        this.loading = true
        let id = record.id
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/deleteById/${id}`)
        let search = handleSeerchAndPage(this.pagination.current, this.pagination, this.searchFields)
        this.searchFields.carseriesCode = this.carCode
        this.searchFields.catalogId = this.editCatalogId
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/getCatalogSpareparts:search`, search)
        runInAction(() => {
            this.list = Array.isArray(res) ? res : []
            this.loading = false
        })

    }

    /**-------------------------------修改----------------------------------------*/
    /**
     * 关闭修改弹框
     */
    @action
    closeUpdateBox = () => {
        runInAction(() => {
            this.fileList = []
            this.updateData = {
                attachment: '',
                id: '',
                grade: '',
                epcCount: '',
                location: '',
                vinNo: '',
                engineCode: '',
                developRemarks: ''
            }
            this.updateModal = false
        })
    }

    /**---------------------------------导入----------------------------*/
    /**
     * 导入车系下拉框初始化
     * @returns {Promise.<void>}
     */
    @action
    showUpload = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/enabledCarseriesCatalogs`)
        runInAction(() => {
            this.carseriesList1 = res || []
            this.loading = false
            this.UploadModal = true
        })
    }

    /**
     * 上传文文件
     */
    @action
    fileUpload = (info) => {
        this.fileList = info.fileList
        this.updateData.attachment = info.file.response
        if (info.file.status === 'removed') {
            this.updateData.attachment = ''
        }
    }

    /**---------------------------------------隐藏和显示------------------------*/
    /**
     * 显示/隐藏
     */
    changeStatus = async (record) => {
        let status = record.isShow ? 0 : 1;
        let id = record.id
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/showOrHide/${id}/status/${status}`)
        if (res && res.status === 500) {
            return
        } else {
            let search = handleSeerchAndPage(this.pagination.current, this.pagination, this.searchFields)
            this.searchFields.carseriesCode = this.carCode
            this.searchFields.catalogId = this.editCatalogId
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/getCatalogSpareparts:search`, search)
            runInAction(() => {
                this.list = Array.isArray(res) ? res : []
            })
        }
        runInAction(() => {
            this.loading = false
        })
    }

    @action
    onEditConfigFieldChange(changedFields) {
        this.formField = {...this.formField, ...changedFields}
    }

    @computed
    get fields() {
        const fields = {
            carseriesName: this.formField.carseriesName,//车系
            code: this.formField.code + this.formField.name,//分组号
            description: this.formField.description//备注
        }
        return objToForm(fields)
    }

    /**
     * 显示修改说明模态框
     * @returns {Promise<void>}
     */
    @action
    showModificationNotesModal = async () => {
        //查询所有配置
        await this.queryAllConfigByCondition()
        let search = handleSeerchAndPage(this.pagination.current, this.pagination, this.searchFields)
        this.searchFields.carseriesCode = this.carCode
        this.searchFields.catalogId = this.editCatalogId
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/getCatalogSpareparts:search`, search)
        runInAction(() => {
            this.list = Array.isArray(res) ? res : []
            this.ModificationNotes = true
            this.editInfoModal = true
        })
    }

    /**
     * 获取修改说明数据
     * @returns {Promise<void>}
     */
    @action
    queryAllConfigByCondition = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/getById/carseriesCode?carseriesCode=${this.carCode}&&id=${this.queryFileds.catalogId}`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
                return
            })
        }
        runInAction(() => {
            this.formField = res
            this.exportPdfModalValue = res
            this.loading = false
        })
    }

    /**
     * 关闭打印模态框
     * @returns {Promise<void>}
     */
    @action
    closeExportModal = async () => {
        runInAction(() => {
            this.ModificationNotes = false
            this.excelModalIsShow = false
            this.formField = {
                modelYearSet: [],
                powerSet: [],
                allocationSet: [],
                transTypeSet: [],
                driveTypeSet: [],
                emissionNormalSet: [],
                carSeriesId: this.searchFields.carseriesId,  //车系id
            }
            this.exportPdfModalValue = {
                carYears: [],//年款
                displacements: [],//排量
                deploys: [], //配置
                transmissions: [], //变速器类型
                driveModels: [],  //驱动方式
                countryAreas: [], //国家及大区
                emissionNormal: []//排放标准
            }
            this.editInfoModal = false
        })
    }

    /**
     * 保存修改说明数据
     * @returns {Promise<void>}
     */
    @action
    saveChangesData = async () => {
        this.loading = true
        let data = this.formField
        data.catalogId = this.queryFileds.catalogId
        data.carseriesCode = this.carCode
        data.groupDescription = this.formField.description.value
        data.description = this.formField.description.value
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/updateGroupDescription`, data)
        await this.initEditPageCarseries(this.carName)
        let search = handleSeerchAndPage(this.pagination.current, this.pagination, this.searchFields)
        search['search.carseriesCode'] = this.carCode
        search['search.catalogId'] = this.editCatalogId
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/getCatalogSpareparts:search`, search)
        runInAction(() => {
            this.linkage = this.formField.description
            this.list = Array.isArray(res) ? res : []
            this.loading = false
            this.ModificationNotes = false
            this.excelModalIsShow = false
            this.createBtnIsShow = true
            this.editInfoModal = false
        })
    }

    /**
     * 重置
     * @returns {Promise<void>}
     */
    @action
    resetExportModal = async () => {
        runInAction(() => {
            this.formField = {
                modelYearSet: [],
                powerSet: [],
                allocationSet: [],
                transTypeSet: [],
                driveTypeSet: [],
                emissionNormalSet: [],
                carSeriesId: this.searchFields.carseriesId,  //车系id
            }
        })
        await this.queryAllConfigByCondition()
    }

    /**
     * 查询pdf按钮权限
     * @returns {Promise<void>}
     */
    @action
    selShowBtn = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/selectUserHavePdfPermission`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
                this.pdfBtnIsShow = false
            })
        }
        runInAction(() => {
            this.loading = false
            this.pdfBtnIsShow = res
        })
    }

    /**
     * 获取模态框下拉数据
     * @returns {Promise<void>}
     */
    @action
    showExcelModal = async () => {
        runInAction(() => {
            this.excelModalIsShow = true
            this.exportExcelModal = true
        })
        let search = {}
        Object.keys(this.formField).forEach(key => {
            if (this.formField[key].value) {
                search[key] = this.formField[key].value
            }
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/groupCongig/querySelectValues/carseriesCode?carseriesCode=${this.carCode}`, search)
        runInAction(() => {
            this.initExportSelectData = {...res}
        })
        // this.getSelectDataSet()
    }

    /**
     * 获取导出备件的不重复的下拉值
     * @param initExportSelectData
     */
    @action
    getSelectDataSet = () => {
        let powerSet = [];
        let allocationSet = []
        let transTypeSet = []
        let driveTypeSet = []
        let emissionNormalSet = []
        runInAction(() => {
            Object.values(this.initExportSelectData).map((e) => {
                e['powerSet'].forEach((item) => powerSet.push(item))
                e['transTypeSet'].forEach((item) => transTypeSet.push(item))
                e['driveTypeSet'].forEach((item) => driveTypeSet.push(item))
                e['emissionNormalSet'].forEach((item) => emissionNormalSet.push(item))
                e['allocationSet'].forEach((item) => allocationSet.push(item))
                return e
            })
            this.powerSet = Array.from(new Set(powerSet));
            this.allocationSet = Array.from(new Set(allocationSet));
            this.transTypeSet = Array.from(new Set(transTypeSet));
            this.driveTypeSet = Array.from(new Set(driveTypeSet));
            this.emissionNormalSet = Array.from(new Set(emissionNormalSet));
        })
    }

    /**
     * 隐藏模态框
     */
    @action
    hideModal = () => {
        runInAction(() => {
            this.formField = {
                modelYearSet: [],
                powerSet: [],
                allocationSet: [],
                transTypeSet: [],
                driveTypeSet: [],
                emissionNormalSet: [],
            }
            this.excelDownloadLoading = false
            this.excelModalIsShow = false
            this.exportExcelModal = false
        })

    }

    /**
     * 选上级时清空下级
     * @param index
     */
    @action
    clearForm = (index) => {
        let list = Object.keys(this.formField)
        list.forEach((item, i) => {
            if (i > index) {
                this.formField[item] = {value: ''}
            }
        })
    }

    /**
     * 备件导出excel
     * @returns {Promise<void>}
     */
    @action
    downloadExcel = async () => {
        runInAction(() => {
            this.excelDownloadLoading = false
            this.formField = {
                modelYearSet: [],
                powerSet: [],
                allocationSet: [],
                transTypeSet: [],
                driveTypeSet: [],
                emissionNormalSet: [],
            }
            this.excelModalIsShow = false
            this.exportExcelModal = false
        })
    }

    /***
     * 选中行的ID
     * @param selectedRowKeys
     */
    @action
    selectedRowKey = (selectedRowKeys) => {
        this.selectedRowKeysId = selectedRowKeys
    }

    /**
     * 批量删除
     * @returns {Promise<void>}
     */
    @action
    deleteSeleteAll = async () => {
        if (this.selectedRowKeysId.length > 0) {
            let res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/batchDel/carseriesCode?carseriesCode=${this.carCode}`, this.selectedRowKeysId)
            let search = handleSeerchAndPage(this.pagination.current, this.pagination, this.searchFields)
            this.searchFields.carseriesCode = this.carCode
            this.searchFields.catalogId = this.editCatalogId
            const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/getCatalogSpareparts:search`, search)
            runInAction(() => {
                this.list = Array.isArray(res1) ? res1 : []
            })
            if (res.status === 0) {
                message.error(res.msg)
            } else {
                message.success('删除成功')
            }
        } else {
            message.warning('请选择您要删除的数据')
            return
        }

    }
    /**---------------------------------------搜索------------------------*/

    /**
     * table选中当前行  左侧目录高亮显示
     * @param record
     */
    @action
    seekData = async (record) => {
        this.selectLeftRowId = record.catalogId
        this.selectLeftRowMaterialNo = record.materialNo
        let onePath = '/' + record.path.split('/')[1]
        let twoPath = record.path.split('/').slice(0, 3).join('/')
        this.expandedLeftRowKeys = [onePath, twoPath]
        this.editQueryAllDataModal = false
        let oneRecord = this.tree.find(item => item.path === onePath)
        let twoRecord = oneRecord.children.find(item => item.path === twoPath)
        let threeRecord = twoRecord.children.find(item => item.path === record.path)
        this.searchByPathAndcarseriesId(null, threeRecord)
    }

    @action
    changeExpandedLeftRowKeys = (expandedRows) => {
        this.expandedLeftRowKeys = expandedRows
    }

    /**---------------------------------------技术属性------------------------*/

    @action
    onEditFieldChange = (changedFields) => {
        this.editTechnologyData = {...this.editTechnologyData, ...ValueObjToObj(changedFields)}
    }

    /**
     * 获取下拉框数据
     * @param record
     * @returns {Promise<void>}
     */
    @action
    initData = async (record) => {
        this.technologyModal = true
        this.technologyLoading = true
        this.loading = true
        this.technologyRow = record
        let id = record.epcSparepartsId
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/sparePart/getSelectValues`)
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/sparePart/getBySpareNo/id/${id}`)
        runInAction(() => {
            let entryTimeEnd = res1.entryTimeEnd === null ? undefined : moment(res1.entryTimeEnd)
            let entryTimeStart = res1.entryTimeStart === null ? undefined : moment(res1.entryTimeStart)
            this.initSelectData = {...this.initSelectData, ...res}
            let sixPhotosList = res1.sixPhotosList && res1.sixPhotosList.map((item, index) => ({
                uid: index,
                url: item,
            }))
            this.editTechnologyData = {
                ...this.editTechnologyData,
                ...res1,
                time: [entryTimeStart, entryTimeEnd],
                sixPhotosList: sixPhotosList || []
            }
            this.loading = false
            this.technologyLoading = false
            this.technicalSettingModal = true
        })
    }

    /***
     * 保存技术属性
     * @returns {Promise<void>}
     */
    save = async () => {
        let list = []
        Object.values(this.editTechnologyData.sixPhotosList).map(item => {
            if (item.response) {
                return list.push(`https://` + item.response.split(':').pop())
            } else {
                return list.push(item.url)
            }
        })
        this.editTechnologyData.id = this.technologyRow.epcSparepartsId
        this.editTechnologyData.entryTimeStart = this.editTechnologyData.time && this.editTechnologyData.time[0] ? this.editTechnologyData.time[0].format("YYYY-MM-DD") : '';
        this.editTechnologyData.entryTimeEnd = this.editTechnologyData.time && this.editTechnologyData.time[1] ? this.editTechnologyData.time[1].format("YYYY-MM-DD") : '';
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/sparePart/updateSparePart`, {
            ...this.editTechnologyData,
            sixPhotosList: list
        })
        runInAction(() => {
            this.technicalSettingModal = false
            message.success('保存成功')
        })
    }

    /**
     * 关闭模态框
     */
    @action
    showTechnologyModal = () => {
        this.technologyModal = false
        this.editQueryAllDataModal = false
        this.queryAllDataModal = false
        this.technicalSettingModal = false
    }

    /***
     * 修改标号
     * @param value
     * @param record
     * @returns {Promise<void>}
     */
    @action
    onBlurGradeData = async (value, record) => {
        let obj = {...this.createData, ...record, grade: value}
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/updateCatalogSparePart`, obj)
        await this.searchByPathAndcarseriesId(this.pagination.current, this.selectLeftRowData)
    }

    /***
     * 修改数量
     * @param value
     * @param record
     * @returns {Promise<void>}
     */
    @action
    onBlurCountData = async (value, record) => {
        let obj = {...this.createData, ...record, epcCount: value}
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/updateCatalogSparePart`, obj)
        await this.searchByPathAndcarseriesId(this.pagination.current, this.selectLeftRowData)
    }

    /*
    Vin导出框显示
     */
    @action
    vinExport = () => {
        this.vinExportModal = true
    }

    @action
    hideVinExportModal = () => {
        this.vinExportModal = false
        this.vinValue = ''
    }

    /***
     * vin导出
     */
    @action
    downloadVinExcel = async () => {
        downLoad(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epcSparepart/exportExcelByVin/vin/${this.vinValue}`, `${this.vinValue}号数据.xls`)
        runInAction(() => {
            this.vinValue = ''
            message.warning('正在导出中，请耐心等待！');
            this.vinExportModal = false
        })
    }

    /***
     * vin导出2
     */
    @action
    downloadVinExcel2 = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/vinQueriesWhetherACarIsAllocated?vin=${this.vin}`)
        if(res === false) {
            runInAction(() => {
                message.warning('vin不存在或未配车系！');
                this.vin = ''
            })
        } else {
            downLoad(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/exportPartsSparePartsAndCatalogInformationFromVIN?vin=${this.vin}`, `${this.vin}-备件数据.xls`)
            runInAction(() => {
                message.warning('正在导出中，请耐心等待！');
                this.vinExportSparePartsModal = false
                this.vin = ''
            })
        }
    }

    /**
     * 查询替换信息
     * @param record
     * @param e
     * @returns {Promise<void>}
     */
    @action
    getReplaceInfo = async (record) => {
        const obj = {
            [`search.bySpareNo`]: record.spareNo,
            [`search.carseriesCode`]: this.carCode,
            [`search.catalogId`]: record.catalogId,
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/getChangeInfoByMaterialNo`, obj)
        runInAction(() => {
            this.replaceDetail = Array.isArray(res) ? res : []
            this.showReplaceModal = true
        })
    }

    @action
    onUpload = (arr) => {
        this.importReturnData = arr
        this.showDrawer = true
    }

    /***
     * 关闭抽屉
     */
    @action
    onClose = () => {
        this.showDrawer = false
    }

    /***
     * 保存排序
     * @returns {Promise<void>}
     */
    @action
    saveSort = async () => {
        let dragList = []
        this.list.forEach((item, index) => {
            dragList.push({
                id: item.id,
                sort: index + 1
            })
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparepart/modifySort`, dragList)
        if (res && res.status === 0) {
            message.error('保存失败');
            return
        }
        runInAction(() => {
            message.success('排序成功');
            this.dragState = false
        })
    }

    /**
     * 上传附件
     * @returns {Promise<void>}
     */
    @action
    epcSparepartCatalogUpload = async (info) => {
        this.loading = false
        if (info.file.status === 'done') {
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/uploadAttachment`, {
                id: this.epcSparepartsCatalogId,
                fileName: info.file.name,
                fileUrl: info.file.response
            })
            message.success(`${info.file.name} 上传成功`)
            await this.searchByPathAndcarseriesId(this.pagination.current, this.selectLeftRowData)
            return
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} 上传失败`)
        }
    }

    /**
     * 删除附件
     * @returns {Promise<void>}
     */
    @action
    deleteAttachment = async (id) => {
        this.loading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/deleteAttachment/${id}`)
        let search = handleSeerchAndPage(this.pagination.current, this.pagination, this.searchFields)
        this.searchFields.carseriesCode = this.carCode
        this.searchFields.catalogId = this.editCatalogId
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/getCatalogSpareparts:search`, search)
        runInAction(() => {
            this.list = Array.isArray(res) ? res : []
            this.loading = false
        })
    }
}

export default new epcSparepartCatalogAttributeStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/EPC/EPCSparepartCatalogAttribute/store.js